import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, useContext } from '@nuxtjs/composition-api';
import TabList from '~/components/TabList.vue';
import { CurriculumBreadcrumb, ResourceCurriculum } from '~/types/resource';


export default /*#__PURE__*/_defineComponent({
  __name: 'CurriculumList',
  props: {
    curriculums: null
  },
  setup(__props: any) {

const props = __props as {
  curriculums: ResourceCurriculum[];
};

const { $config } = useContext();


const modalHeading = ref<HTMLElement | null>(null);

onMounted(() => {
  modalHeading.value?.focus();
  //console.log('curriculums', props.curriculums);
});

const getBreadcrumbLink = (
  curriculum: ResourceCurriculum,
  breadcrumbs: CurriculumBreadcrumb[],
  breadcrumb: CurriculumBreadcrumb
) => {
  if (curriculum.name !== $config.curriculumV9) {
    return breadcrumb.link;
  } else {
    let year;
    for (const i in breadcrumbs) {
      if (regexBreadcrumb.exec(breadcrumbs[i].name)) {
        year = breadcrumbs[i].name.toLowerCase().replace(/\s/g, '-');
        break;
      }
    }
    return breadcrumb.link + (year ? '?year_levels[]=' + year : '');
  }
};

const createParentLinkforNewCuriculum = (
  curriculumNewVersion: ResourceCurriculum,
  curriculumCode: string
) => {
  const curriculumCodeLinks = curriculumNewVersion.items.find(code => code.slug === curriculumCode);
  const curriculumCodeParentLinks =
    curriculumCodeLinks?.breadcrumbs[curriculumCodeLinks?.breadcrumbs.length - 1];
  return curriculumCodeParentLinks?.link + '?curriculum[]=' + curriculumCode;
};

const curriculumVersionItem = props.curriculums.find(
  curriculumVersion => curriculumVersion.name === $config.curriculumV9
) as ResourceCurriculum;

const regexBreadcrumb = /^(?:foundation|grade|year)/i;

return { __sfc: true,$config, props, modalHeading, getBreadcrumbLink, createParentLinkforNewCuriculum, curriculumVersionItem, regexBreadcrumb, TabList }
}

})